module.exports = __webpack_public_path__ + "static/media/lizScene-02.cc03a1c5.jpg";